var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NodeId',{attrs:{"node_id":_vm.$route.params.node_id}})
}
var staticRenderFns = []

export { render, staticRenderFns }